// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"a17431f1","355":"81257527"}[chunkId] + ".chunk.js";
};